<script setup lang="ts">
import { computed, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{
    title: string;
    hover: boolean;
    class: string;
    emoji?: string;
    titleClass?: string;
    path?: string;
    action?: () => void;
    bordered?: boolean;
  }>(),
  {
    emoji: undefined,
    titleClass: undefined,
    path: undefined,
    action: undefined,
    bordered: undefined,
  }
);

const slots = defineSlots<{
  icon(props: object): any;
  right(props: object): any;
}>();

const hoverClasses = computed(
  () => 'group [&:not(.router-link-active)]:hover:shadow-s-hover hover:bg-white hover:text-black dark:hover:text-gray-500'
);
const classes = computed(
  () =>
    (props.hover ? hoverClasses.value : '') +
    ' select-none side-menu__item  flex items-center flex-start rounded-6 h-[48px] laptop:h-[34px] ' +
    ` ${props.bordered ? '[&:not(.router-link-active)]:bordered-menu' : ''} ` +
    'text-buttons pl-[11px] pr-[4px] [&.router-link-active]:bg-gray-250 text-black dark:text-gray-500 dark:[&.router-link-active]:bg-gray-900 dark:hover:bg-gray-750 ' +
    props.class
);
</script>

<template>
  <router-link v-if="props.path" :to="props.path" :class="classes">
    <span class="flex flex-1 items-center justify-between">
      <span class="flex items-center gap-xs">
        <slot name="icon"></slot>
        <span class="text-caption-s overflow-hidden overflow-ellipsis whitespace-nowrap" :class="props.titleClass">{{ props.title }}</span>
        <span v-if="props.emoji">{{ props.emoji }}</span>
      </span>
      <slot name="right"></slot>
    </span>
  </router-link>

  <button v-else-if="!!action" :class="classes" @click="() => props.action && props.action()">
    <span class="flex flex-1 items-center justify-between">
      <span class="flex items-center gap-xs">
        <slot name="icon"></slot>
        <span class="text-caption-s overflow-hidden overflow-ellipsis whitespace-nowrap" :class="props.titleClass">{{ props.title }}</span>
        <span v-if="props.emoji">{{ props.emoji }}</span>
      </span>
      <slot name="right"></slot>
    </span>
  </button>

  <span v-else :class="classes">
    <span class="flex flex-1 items-center justify-between">
      <span class="flex items-center gap-xs">
        <slot name="icon"></slot>
        <span class="text-caption-s overflow-hidden overflow-ellipsis whitespace-nowrap" :class="props.titleClass">{{ props.title }}</span>
        <span v-if="props.emoji">{{ props.emoji }}</span>
      </span>
      <slot name="right"></slot>
    </span>
  </span>
</template>
